import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, db } from '../firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';
import { CircularProgress, Box } from '@mui/material';

const PrivateRoute = ({ children }) => {
  const [user, loading] = useAuthState(auth);
  const [isArchived, setIsArchived] = useState(false);
  const [checkingArchiveStatus, setCheckingArchiveStatus] = useState(true);
  
  useEffect(() => {
    const checkUserArchiveStatus = async () => {
      if (user) {
        try {
          const userDoc = await getDoc(doc(db, 'users', user.uid));
          if (userDoc.exists() && userDoc.data().isArchived) {
            setIsArchived(true);
            // Déconnecter l'utilisateur archivé
            await auth.signOut();
          }
        } catch (error) {
          console.error('Erreur lors de la vérification du statut d\'archivage:', error);
        }
      }
      setCheckingArchiveStatus(false);
    };

    if (!loading) {
      checkUserArchiveStatus();
    }
  }, [user, loading]);

  if (loading || checkingArchiveStatus) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (isArchived) {
    return <Navigate to="/login" />;
  }
  
  return user ? children : <Navigate to="/login" />;
};

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
};


export default PrivateRoute;
